<template>
    <div class="container-fluid">
    <div class="row">
      <!-- Linke Seite: Formular -->
      
      
      <div class="col-12 col-md-3 col-lg-3 col-xl-4 custom-width-desktop">
        <div  class="scrollable-container">
              
        <div class="scrollable-div bg-light shadow-lg rounded-lg p-2">

    
        
        
        
            
            <div class="text-center">

              <h2 class="h2" style="font-family: karla;">
                Monitor Finder
                  <img src="https://monitorwelt.de/logo_small.png" class="img-fluid" style="width: 20%;" alt="...">
              </h2>
              <h4 class="h4 mt-2" style="font-family:Open Sans,Arial,sans-serif">
                Zu viel Technik? Alternativ probiere unsere <a href="https://monitorwelt.de/personalisierte-monitor-kaufberatung" style="font-size:1.3rem;color: #007bff; text-decoration: underline;">
                  smarte Monitor-Kaufberatung</a> aus.
              </h4>
            </div>
            <form method="GET" name="finder-form" id="finder-form" @change="onFormChange">
              <div class="formContent p-2">
              <div class="row row-cols-2">
                <div class="ml-2 mb-3 w-[80%]">


                  <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">
                    Hersteller
                  </span>
                  <select v-model="filters.brand" id="brand" name="brand" class="spanSelectField form-select form-select-md-lg mb-1">
                    <option value="Alle" selected>Alle</option>
                    <option value="Acer">Acer</option>
                    <option value="AOC">AOC</option>
                    <option value="Asus">Asus</option>
                    <option value="BenQ">BenQ</option>
                    <option value="Dell">Dell</option>
                    <option value="EIZO">Eizo</option>
                    <option value="Fujitsu">Fujitsu</option>
                    <option value="GigaByte">GigaByte</option>
                    <option value="HANNspree">HANNspree</option>
                    <option value="HP">HP</option>
                    <option value="Iiyama">Iiyama</option>
                    <option value="Lenovo">Lenovo</option>
                    <option value="LG">LG</option>
                    <option value="MSI">MSI</option>
                    <option value="Philips">Philips</option>
                    <option value="Samsung">Samsung</option>
                    <option value="Viewsonic">Viewsonic</option>>
                  </select>
                </div>

                <div class="ml-2 mb-3 w-[80%]">
                  <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">
                    Auflösung
                  </span>
                  <select v-model="filters.resolution" id="resolution" name="resolution" class="spanSelectField form-select form-select-md-lg mb-1">

                    <option value="Alle" selected>Alle</option>
                      <optgroup label="Klassische Auflösungen">
                        <option value="1920x1080">1920x1080 (FULL HD)</option>
                        <option value="2560x1440">2560x1440 (QHD)</option>
                        <option value="3840x2160">3840x2160 (4K)</option>
                      </optgroup>
                      <optgroup label="Ultrawide Auflösungen">
                        <option value="3440x1440">3440x1440 (Ultrawide)</option>
                        <option value="5120x1440">5120x1440 (Super-Ultrawide, ab 40 Zoll)</option>
                        
                      </optgroup>
                      <optgroup label="Seltene Auflösungen">
                      <option value="1920x1200">1920x1200 (16:10)</option>
                      <option value="2560x1080">2560x1080 (21:9)</option>
                      <option value="2560x1600">2560x1600 (16:10)</option>
                      <option value="3840x1600">3840x1600 (38 Zoll)</option>
                      </optgroup>
                  </select>
                </div>
                <div class="ml-2 mb-3 w-[80%]">
                  <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color ">
                    Größe
                  </span>
                  <select v-model="filters.size" id="size" name="size" class="spanSelectField form-select form-select-md-lg mb-1">
                    <option value="0">Alle</option>
                    <option value="22">22"</option>
                    <option value="24">24"</option>
                    <option value="27">27"</option>
                    <option value="28">28"</option>
                    <option value="29">29"</option>
                    <option value="30">30"</option>
                    <option value="32">32"</option>
                    <option value="34">34"</option>
                    <option value="35">35" bis 40"</option>
                    <option value="40">Größer als 40"</option>
                    
                  </select>
                </div>
                <div class="ml-2 mb-3 w-[80%]">
                  <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color ">Panel-Art</span>

                  <select v-model="filters.panel" id="panel" name="panel" class="spanSelectField form-select form-select-md-lg mb-1">

                    <option value="Alle" selected>Alle</option>
                    <option value="VA">VA</option>
                    <option value="TN">TN</option>
                    <option value="IPS">IPS</option>
                    <option value="OLED">OLED</option>
                  </select>
                </div>
                <div class="ml-2 mb-3 w-[80%]">
                  <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color ">Reaktionszeit</span>

                  <select v-model="filters.reaktionszeit" id="reactionTime" name="reactionTime" class="spanSelectField spanSelectField form-select form-select-md-lg mb-1">
                    <option value="1">1 ms</option>
                    <option value="2">2 ms</option>
                    <option value="4">4 ms</option>
                    <option value="6">6 ms</option>
                    <option value="8">8 ms</option>
                    <option value="10" selected>10 ms</option>
                  </select>
                </div>
                <div class="ml-2 mb-3 w-[80%]">
  <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">Curved</span>
  <select v-model="filters.isCurved" id="isCurved" name="isCurved" class="spanSelectField form-select form-select-md-lg mb-1">
    <option value="2" selected>Egal</option>
    <option value="1">Ja</option>
    <option value="0">Nein</option>
  </select>
</div>
                <div class="ml-2 mb-3 w-[80%]">

                  <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color ">Frequenz</span>

                  <select v-model="filters.frequenz" id="hertz" name="hertz" class="spanSelectField form-select form-select-md-lg mb-1">

                    <option value="0" selected>60 Hz</option>
                    <option value="100">100 Hz</option>
                    <option value="120">120 Hz</option>
                    <option value="144">144 Hz</option>
                    <option value="240">240 Hz</option>
                  </select>
                </div>
                <div class="ml-2 mb-3 w-[80%]">
                  <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color ">Ultrawide-Screen</span>

                  <select v-model="filters.ultrawide" id="ultrawide" name="ultrawide" class="spanSelectField form-select form-select-md-lg mb-1">

                    <option value="2" selected>Egal</option>
                    <option value="1">Ja</option>
                    <option value="0">Nein</option>
                  </select>
                </div>
              </div>

              <div class="">
              <div class="mb-1 flex">
                <h4
                  class="text-xs text-center  font-semibold  mb-2 py-1 px-2 uppercase rounded text-black bg-[#C2AB92] uppercase last:mr-0 mr-1">
                  Anschlüsse
                </h4>
              </div>

              <div class="container" style="padding-top:0px;">
  <div class="row" style="margin-left:15%">
    <div class="col-md-6 d-flex mb-4">
      <div class="form-check form-switch d-flex">
        <input class="form-check-input me-2" type="checkbox" id="hdmi" v-model="filters.hdmi" value="1" true-value="1" false-value="0">
        <label class="form-check-label" for="hdmi">HDMI</label>
      </div>
    </div>
    <div class="col-md-6 d-flex mb-4">
      <div class="form-check form-switch d-flex">
        <input class="form-check-input me-2" type="checkbox" id="vga" v-model="filters.vga" value="1" true-value="1" false-value="0">
        <label class="form-check-label" for="vga">VGA</label>
      </div>
    </div>
    <div class="col-md-6 d-flex mb-4">
      <div class="form-check form-switch d-flex ">
        <input class="form-check-input me-2" type="checkbox" id="dvi" v-model="filters.dvi" value="1" true-value="1" false-value="0">
        <label class="form-check-label" for="dvi">DVI</label>
      </div>
    </div>
    <div class="col-md-6 d-flex mb-4">
      <div class="form-check form-switch d-flex">
        <input class="form-check-input me-2" type="checkbox" id="displayport" v-model="filters.displayport" value="1" true-value="1" false-value="0">
        <label class="form-check-label" for="displayport">DisplayPort</label>
      </div>
    </div>
  </div>
</div>
</div>


              <!-- Preis Slider -->
      <div class="mt-5" id="slider"></div>
      <input type="text" id="minCost"  readonly hidden>
      <input type="text" id="maxCost" readonly hidden>
      
              <!--Versuch Slider
              <div id="slider" class="mr-2"></div>

              <input type="text" class="price-min" id="minCost" name="minPrice" value="100" hidden />
              <input type="text" class="price-max" id="maxCost" name="maxPrice" value="3500" hidden />
              -->
              <div class="mt-3">
  <details>
    <summary>Weitere Office-Eigenschaften</summary>
    <div class="container pt-2">
      <div class="row row-cols-2">

        <div class="col-md-6">
          <div class="ml-2 mb-3 w-[80%]">
            <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color ">Höhenverstellbar</span>
            <select v-model="filters.isHoehenverstellbar" id="isHoehenverstellbar" name="isHoehenverstellbar" class="spanSelectField form-select form-select-md-lg mb-1">
              <option value="2">Alle</option>
              <option value="1">Ja</option>
            </select>
          </div>
        </div>

        <div class="col-md-6">
        <div class="ml-2 mb-3 w-[80%]">
  <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">PPI/DPI</span>
  <select v-model="filters.ppi" id="ppi" name="ppi" class="spanSelectField form-select form-select-md-lg mb-1">
    <option value="0" selected>ab 40 Pixel pro Zoll</option>
    <option value="60">ab 60 Pixel pro Zoll</option>
    <option value="80">ab 80 Pixel pro Zoll</option>
    <option value="100">ab 100 Pixel pro Zoll</option>
    <option value="110">ab 110 Pixel pro Zoll</option>
    <option value="120">ab 120 Pixel pro Zoll</option>
    <option value="130">ab 130 Pixel pro Zoll</option>
    <option value="140">ab 140 Pixel pro Zoll</option>
    <option value="150">ab 150 Pixel pro Zoll</option>
    <option value="160">ab 160 Pixel pro Zoll</option>
    <option value="180">ab 180 Pixel pro Zoll</option>
  </select>
</div>
</div>

        <div class="col-md-6">
          <div class="ml-2 mb-3 w-[80%]">
            <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color ">Blaulichtfilter</span>
            <select v-model="filters.blaulichtfilter" id="blaulichtfilter" name="blaulichtfilter" class="spanSelectField form-select form-select-md-lg mb-1">
              <option value="2">Alle</option>
              <option value="1">Ja</option>
            </select>
          </div>
        </div>

        <div class="ml-2 mb-3 w-[80%]">
  <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">Energieklasse</span>
  <select v-model ="filters.energieklasse" id="energyclass" name="energyclass" class="spanSelectField form-select form-select-md-lg mb-1">
    <option value="Alle">Alle</option>
    <option value="A++">A++</option>
    <option value="A+">A+</option>
    <option value="A">A</option>
    <option value="B">B</option>
    <option value="C">C</option>
    <option value="D">D</option>
  </select>
</div>

<div class="ml-2 mb-3 w-[80%]">
  <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">Neigbarkeit</span>
  <select v-model="filters.isNeigbar" id="isNeigbar" name="isNeigbar" class="spanSelectField form-select form-select-md-lg mb-1">
    <option value="2">Alle</option>
    <option value="1">Ja</option>
    <option value="0">Nein</option>
  </select>
</div>

<div class="ml-2 mb-3 w-[80%]">
  <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">Schwenkbarkeit</span>
  <select v-model="filters.isSchwenkbar" id="isSchwenkbar" name="isSchwenkbar" class="spanSelectField form-select form-select-md-lg mb-1">
    <option value="2">Alle</option>
    <option value="1">Ja</option>
    <option value="0">Nein</option>
  </select>
</div>

<div class="ml-2 mb-3 w-[80%]">
  <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">Vesa-Halterung</span>
  <select v-model="filters.isVesa" id="vesa" name="vesa" class="spanSelectField form-select form-select-md-lg mb-1">
    <option value="2">Alle</option>
    <option value="1">Ja</option>
  </select>
</div>

<div class="ml-2 mb-3 w-[80%]">
  <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">Lautsprecher</span>
  <select v-model="filters.isSpeaker" id="speaker" name="speaker" class="spanSelectField form-select form-select-md-lg mb-1">
    <option value="2">Alle</option>
    <option value="1">Ja</option>
  </select>
</div>

<div class="ml-2 mb-3 w-[80%]">
  <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">Drehbar (180°)</span>
  <select v-model="filters.isHochformat" id="isHochformat" name="isHochformat" class="spanSelectField form-select form-select-md-lg mb-1">
    <option value="2">Alle</option>
    <option value="1">Ja</option>
  </select>
</div>

<div class="ml-2 mb-3 w-[80%]">
  <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">Flickerfrei</span>
  <select v-model="filters.isFlickerfrei" id="isFlickerfrei" name="isFlickerfrei" class="spanSelectField form-select form-select-md-lg mb-1">
    <option value="2">Alle</option>
    <option value="1">Ja</option>
  </select>
</div>

<div class="col-md-6">
          <div class="ml-2 mb-3 w-[80%]">
            <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color ">Inkl. Kamera</span>
            <select v-model="filters.isKamera" id="isKamera" name="isKamera" class="spanSelectField form-select form-select-md-lg mb-1">
              <option value="2">Alle</option>
              <option value="1">Ja</option>
            </select>
          </div>
        </div>

      </div>
    </div>
  </details>

  <details>
    <summary>Weitere Gaming-Eigenschaften</summary>
    <div class="container pt-2">
      <div class="row row-cols-2">

        <div class="col-md-6">
          <div class="ml-2 mb-3 w-[80%]">
            <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color ">Gsync</span>
            <select v-model="filters.isGsync" id="isGsync" name="isGsync" class="spanSelectField form-select form-select-md-lg mb-1">
              <option value="2">Alle</option>
              <option value="1">Ja</option>
            </select>
          </div>
        </div>

        <div class="col-md-6">
          <div class="ml-2 mb-3 w-[80%]">
            <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color ">FreeSync</span>
            <select v-model="filters.isFreeSync" id="isFreeSync" name="isFreeSync" class="spanSelectField form-select form-select-md-lg mb-1">
              <option value="2">Alle</option>
              <option value="1">Ja</option>
            </select>
          </div>
        </div>

        <div class="col-md-6">
          <div class="ml-2 mb-3 w-[80%]">
            <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color ">HDR</span>
            <select v-model="filters.isHdr" id="isHdr" name="isHdr" class="spanSelectField form-select form-select-md-lg mb-1">
              <option value="2">Alle</option>
              <option value="1">Ja</option>
              <option value="0">Nein</option>

            </select>
          </div>
        </div>

        <div class="col-md-6">
          <div class="ml-2 mb-3 w-[80%]">
            <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color ">Farbtiefe</span>
            <select v-model="filters.farbtiefe" id="farbtiefe" name="farbtiefe" class="spanSelectField form-select form-select-md-lg mb-1">
              <option value="2">Alle</option>
              <option value="8">8 Bit</option>
              <option value="10">10 Bit</option>

            </select>
          </div>
        </div>

        <div class="col-md-6">
        <div class="ml-2 mb-3 w-[80%]">

<span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color ">Helligkeit</span>

<select v-model="filters.helligkeit" id="helligkeit" name="helligkeit" class="spanSelectField form-select form-select-md-lg mb-1">

  <option value="0" selected>Alle</option>
  <option value="200">200 cdm</option>
  <option value="250">250 cdm</option>
  <option value="300">300 cdm</option>
  <option value="350">350 cdm</option>
  <option value="400">400 cdm</option>
  <option value="450">450 cdm</option>
</select>
</div>
</div>

        <div class="col-md-6">
        <div class="ml-2 mb-3 w-[80%]">
  <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">Gehäusefarbe</span>
  <select v-model="filters.farbe" id="colour" name="farbe" class="spanSelectField form-select form-select-md-lg mb-1">
    <option value="Alle" selected>Alle</option>
    <option value="Schwarz">Schwarz</option>
    <option value="Anthrazit">Anthrazit</option>
    <option value="Grau">Grau</option>
    <option value="Weiß">Weiß</option>
    <option value="Silber">Silber</option>
    <option value="Rot">Rot</option>
  </select>
</div>
</div>

      </div>
    </div>
  </details>
</div>

              <div class="form-footer mt-2">
    <button type="reset" class="btn btn-secondary btn-sm px-4 py-2">Auswahl zurücksetzen</button>
</div><!-- end .form-footer section -->
              </div>
            </form>
          
          </div>
          </div>
        </div>
        









        <!-- Rechte Seite: Freier Bereich -->
        
        <div class="col-12 col-md-9 col-lg-9 col-xl-8 d-flex align-items-center justify-content-center">
          <div v-if="loading" class="loading-spinner"></div>
          <div v-else>
<div class="row mb-5 gy-5">

<div class="col-lg-4" v-if="topProducts.bestVal">
  <div class="winner-card">

    <div class="badge-ribbon badge-gaming">
      <i class="fa-solid fa-gamepad me-2"></i> Gaming: Preis/Leistung Tipp
    </div>

    <div class="p-3" style="
    padding-bottom: 0px !important;
">

      <h5 class="text-center">
        {{ topProducts.bestVal.amazonNamenSuche }}
      </h5>

      <pic-carousel :product="topProducts.bestVal" />

<div class="mt-3 mb-3" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 1px; background-color: #050505; border: 2px solid #050505; border-radius: 2px; overflow: hidden;">
  
  <div class="d-flex align-items-center gap-2 p-2" style="background-color: #f4f4f4;">
    <i class="fa-solid fa-desktop" style="color: #737373; font-size: 16px; width: 16px; text-align: center;"></i>
    <span style="font-size: 13px; font-weight: 550; color: #050505; line-height: 1;">{{ topProducts.bestVal.diagonale }} Zoll</span>
  </div>

  <div class="d-flex align-items-center gap-2 p-2" style="background-color: #f4f4f4;">
    <i class="fa-solid fa-expand" style="color: #737373; font-size: 16px; width: 16px; text-align: center;"></i>
    <span style="font-size: 13px; font-weight: 550; color: #050505; line-height: 1;">{{ topProducts.bestVal.aufloesung }}</span>
  </div>

  <div class="d-flex align-items-center gap-2 p-2" style="background-color: #f4f4f4;">
    <i class="fa-solid fa-circle-half-stroke" style="color: #737373; font-size: 16px; width: 16px; text-align: center;"></i>
    <span style="font-size: 13px; font-weight: 550; color: #050505; line-height: 1;">{{ topProducts.bestVal.paneltyp }}</span>
  </div>

  <div class="d-flex align-items-center gap-2 p-2" style="background-color: #f4f4f4;">
    <i class="fa-solid fa-gauge-high" style="color: #737373; font-size: 16px; width: 16px; text-align: center;"></i>
    <span style="font-size: 13px; font-weight: 550; color: #050505; line-height: 1;">{{ topProducts.bestVal.frequenz }} Hz</span>
  </div>

</div>
      <div class="text-center">
        <div class="footer-content d-flex justify-content-between">
          <div class="shop-info">
            <img class="shop-icon" src="/wp-content/plugins/monitorFinderNewTry/amazon_icon.png" alt="Amazon Logo" />
            <div class='' style='text-align: left; font-size: 12px;'>
              aktualisiert: {{ topProducts.bestVal.updated_time }}
            </div>
          </div>
          <div class="amazon-info">
            <div>
              <div class="no_click">
                <span class="price">{{ formatPreis(topProducts.bestVal.preisAmazonNeu) }} €</span>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <a
    :href="topProducts.bestVal.amazon_url"
    target="_blank"
    rel="sponsored nofollow noopener"
    class="btn btn-primary w-100"
    >
    Zum Angebot*
    </a>

  </div>
</div>
<div class="col-lg-4" v-if="topProducts.bestAverage">
<div class="winner-card">

<div class="badge-ribbon badge-testsieger">
<i class="fa-solid fa-display me-2"></i>Allrounder: Preis/Leistung Tipp
</div>

    <div class="p-3" style="
    padding-bottom: 0px !important;
">

      <h5 class="text-center">
        {{ topProducts.bestAverage.amazonNamenSuche }}
      </h5>
      <pic-carousel :product="topProducts.bestAverage" />

<div class="mt-3 mb-3" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 1px; background-color: #050505; border: 2px solid #050505; border-radius: 2px; overflow: hidden;">
  
  <div class="d-flex align-items-center gap-2 p-2" style="background-color: #f4f4f4;">
    <i class="fa-solid fa-desktop" style="color: #737373; font-size: 16px; width: 16px; text-align: center;"></i>
    <span style="font-size: 13px; font-weight: 550; color: #050505; line-height: 1;">{{ topProducts.bestAverage.diagonale }} Zoll</span>
  </div>

  <div class="d-flex align-items-center gap-2 p-2" style="background-color: #f4f4f4;">
    <i class="fa-solid fa-expand" style="color: #737373; font-size: 16px; width: 16px; text-align: center;"></i>
    <span style="font-size: 13px; font-weight: 550; color: #050505; line-height: 1;">{{ topProducts.bestAverage.aufloesung }}</span>
  </div>

  <div class="d-flex align-items-center gap-2 p-2" style="background-color: #f4f4f4;">
    <i class="fa-solid fa-circle-half-stroke" style="color: #737373; font-size: 16px; width: 16px; text-align: center;"></i>
    <span style="font-size: 13px; font-weight: 550; color: #050505; line-height: 1;">{{ topProducts.bestAverage.paneltyp }}</span>
  </div>

  <!-- Zelle 4: Geschwindigkeit -->
  <div class="d-flex align-items-center gap-2 p-2" style="background-color: #f4f4f4;">
    <i class="fa-solid fa-gauge-high" style="color: #737373; font-size: 16px; width: 16px; text-align: center;"></i>
    <span style="font-size: 13px; font-weight: 550; color: #050505; line-height: 1;">{{ topProducts.bestAverage.frequenz }} Hz</span>
  </div>

</div>
      <div class="text-center">
        <div class="footer-content d-flex justify-content-between">
          <div class="shop-info">
            <img class="shop-icon" src="/wp-content/plugins/monitorFinderNewTry/amazon_icon.png" alt="Amazon Logo" />
            <div class='' style='text-align: left; font-size: 12px;'>
              aktualisiert: {{ topProducts.bestAverage.updated_time }}
            </div>
          </div>
          <div class="amazon-info">
            <div>
              <div class="no_click">
                <span class="price">{{ formatPreis(topProducts.bestAverage.preisAmazonNeu) }} €</span>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

<a :href="topProducts.bestAverage.amazon_url" rel="sponsored nofollow noopener" target="_blank">
<button class="btn-primary w-100">
Zum Angebot*
</button>
</a>

</div>
</div>

<div class="col-lg-4" v-if="topProducts.bestPreis">
<div class="winner-card">

<div class="badge-ribbon badge-preisleistung">
<i class="fa-solid fa-piggy-bank me-2"></i>Kleinster Preis
</div>

    <div class="p-3" style="
    padding-bottom: 0px !important;
">

      <h5 class="text-center">
        {{ topProducts.bestPreis.amazonNamenSuche }}
      </h5>

      <pic-carousel :product="topProducts.bestPreis" />

<div class="mt-3 mb-3" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 1px; background-color: #050505; border: 2px solid #050505; border-radius: 2px; overflow: hidden;">
  
  <div class="d-flex align-items-center gap-2 p-2" style="background-color: #f4f4f4;">
    <i class="fa-solid fa-desktop" style="color: #737373; font-size: 16px; width: 16px; text-align: center;"></i>
    <span style="font-size: 13px; font-weight: 550; color: #050505; line-height: 1;">{{ topProducts.bestPreis.diagonale }} Zoll</span>
  </div>

  <div class="d-flex align-items-center gap-2 p-2" style="background-color: #f4f4f4;">
    <i class="fa-solid fa-expand" style="color: #737373; font-size: 16px; width: 16px; text-align: center;"></i>
    <span style="font-size: 13px; font-weight: 550; color: #050505; line-height: 1;">{{ topProducts.bestPreis.aufloesung }}</span>
  </div>

  <div class="d-flex align-items-center gap-2 p-2" style="background-color: #f4f4f4;">
    <i class="fa-solid fa-circle-half-stroke" style="color: #737373; font-size: 16px; width: 16px; text-align: center;"></i>
    <span style="font-size: 13px; font-weight: 550; color: #050505; line-height: 1;">{{ topProducts.bestPreis.paneltyp }}</span>
  </div>

  <div class="d-flex align-items-center gap-2 p-2" style="background-color: #f4f4f4;">
    <i class="fa-solid fa-gauge-high" style="color: #737373; font-size: 16px; width: 16px; text-align: center;"></i>
    <span style="font-size: 13px; font-weight: 550; color: #050505; line-height: 1;">{{ topProducts.bestPreis.frequenz }} Hz</span>
  </div>

</div>

      <div class="text-center">
        <div class="footer-content d-flex justify-content-between">
          <div class="shop-info">
            <img class="shop-icon" src="/wp-content/plugins/monitorFinderNewTry/amazon_icon.png" alt="Amazon Logo" />
            <div class='' style='text-align: left; font-size: 12px;'>
              aktualisiert: {{ topProducts.bestPreis.updated_time }}
            </div>
          </div>
          <div class="amazon-info">
            <div>
              <div class="no_click">
                <span class="price">{{ formatPreis(topProducts.bestPreis.preisAmazonNeu) }} €</span>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

<a :href="topProducts.bestPreis.amazon_url" rel="sponsored nofollow noopener" target="_blank">
<button class="btn-primary w-100">
Zum Angebot*
</button>
</a>

</div>
</div>

</div>
            <div class="row">
            <template v-for="(product, index) in products" :key="product.id">
    <div 
      v-if="
      product.id !== topProducts.bestPreis?.id &&
      product.id !== topProducts.bestAverage?.id &&
      product.id !== topProducts.bestVal?.id
      "
      class="col-lg-4 mb-4"
      :class="getCardAnimationClass(index)"
    >
                        <div class="card" :class="{ 'is-flipped': isFlipped(index) }">
              <div class="card-front">
                <h5 class="card-title text-center mt-3 mx-5">
                  {{ product.amazonNamenSuche }}
                </h5>
                <pic-carousel :product="product" />
                <div class="card-body">
                  <!--<product-chart :product="product" /> -->
                  <div class="row">
  <div class="col-12 col-sm-6 col-lg-6">
    <div class="d-flex flex-column">
      <div>
        <span class="label-data-front mx-2">Größe</span>
      </div>
      <div>
        <span class="ml-2">{{ product.diagonale }} Zoll</span>
      </div>
      <div>
        <span class="label-data-front mx-2">Panel</span>
      </div>
      <div>
        <span class="ml-2">{{ product.paneltyp }}</span>
      </div>
    </div>
  </div>

  <div class="col-12 col-sm-6 col-lg-6">
    <div class="d-flex flex-column">
      <div>
        <span class="label-data-front mx-2">Auflösung</span>
      </div>
      <div>
        <span class="ml-2">{{product.horizontalPixel}}x{{product.vertikalPixel}}</span>
      </div>
      <div>
        <span class="label-data-front mx-2">Frequenz</span>
      </div>
      <div>
        <span class="ml-2">{{ product.frequenz }} Hz</span>
      </div>
    </div>
  </div>
</div>

                </div>
                <button class="datasheet-button" @click="flipCard(index)">
                  <i class="fa-solid fa-rotate-right icon-margin-right"></i> Daten aufklappen
                </button>
                <div class="card-footer">
                  <div class="footer-content d-flex justify-content-between">
                    <div class="shop-info">
                      <span class="no_click">Amazon.de</span>
                      <div class='' style='text-align: left; font-size: 12px; font-family:karla;'>
                        aktualisiert: {{ product.updated_time }}
                      </div>
                    </div>
                    <div class="amazon-info">
                      <div class="pb-2">
                        <div class="no_click pb-1">
                          <img class="shop-icon" src="/wp-content/plugins/monitorFinderNewTry/amazon_icon.png" alt="Amazon Logo" />
                          <span class="mr-2">| </span><span class="price">{{ formatPreis(product.preisAmazonNeu) }}
                            €</span><br />
                        </div>
                        <a :href="product.amazon_url" rel="sponsored nofollow noopener" target="_blank">
                          <button class="btn12 px-3 py-1">zum Angebot*</button>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-back">
                <div class="card-body">
                  <DatenblattMod :product="product" />
                  <button class="datasheet-button" @click="flipCard(index)"><i
                      class="fa-solid fa-rotate-left icon-margin-right"></i>Zurück zur Übersicht</button>
                </div>
              </div>



            </div>
          </div>
        
        
        </template>
    </div>

    <div class="text-center">
    <button class="btn btn-success mb-4" @click="updateMonitors">
              Mehr laden
            </button>  
  </div>
      </div>
          
      </div>
    </div>
  </div>
</template>

<script>
import PicCarousel from "./PicCarousel.vue";
import DatenblattMod from "./DatenblattMod.vue";

export default {
  
  components: {
    PicCarousel,
    DatenblattMod,
  },
  name: 'MonitorFinderApp',
  props: {
    
  },


  data(){
    return {
      flippedCards: [], // Array zum Verfolgen der umgedrehten Karte
      // Hier müssen vermutlich alle !möglichen! filter hin
      products: [],
      topProducts: {
        bestPreis: null,
        bestAverage: null,
        bestVal: null
      },
      loading: false,
      loadedProducts: [], // geladene Produkte wo immer 8 hinzugefuegt werden
      productsPerLoad: 15, // Anz zu ladenden  produkte
      loadedProductIndex: 15,
      
      filters : {
        brand: 'Alle',
        resolution: 'Alle',
        size: '0',
        panel: 'Alle',
        reaktionszeit: '10',
        frequenz: '0',
        ultrawide: '2',
        hdmi: '1',
        vga: '0',
        dvi: '0',
        displayport: '0',
        minPrice: '80',
        maxPrice: '3500',
        farbe: "Alle",
        blaulichtfilter: "2",
        energieklasse: "Alle",
        isNeigbar: "2",
        isSchwenkbar: "2",
        isVesa: "2",
        isSpeaker: "2",
        isHochformat: "2",
        isFlickerfrei: "2",
        isHoehenverstellbar: "2",
        isKamera: "2",
        isGsync: "2",
        isFreeSync: "2",
        isHdr: "2",
        farbtiefe: "2",
        isCurved: "2",
        helligkeit: "0",
        ppi : "0"
        }
  };
    },
  methods: {
    formatPreis(preis) {
      if (!preis) return '';
      return parseFloat(preis).toLocaleString('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },

    initializeSlider() {
                    var slider = document.getElementById('slider');
                    noUiSlider.create(slider, {
                        connect: true,
                        behaviour: 'tap',
                        start: [this.filters.minPrice, this.filters.maxPrice],
                        format: wNumb({
                            decimals: 0,
                            suffix: ' (€)',
                        }),
                        tooltips: true,
                        range: {
                            'min': [0],
                            '80%': [500, 50],
                            '95%': [1000, 500],
                            'max': [3500]
                        }
                    });

                    slider.noUiSlider.on('change', () => {
                        this.filters.minPrice = parseInt(slider.noUiSlider.get()[0].replace(' (€)', ''));
                        this.filters.maxPrice = parseInt(slider.noUiSlider.get()[1].replace(' (€)', ''));
                        this.fetchProducts(this.filters);  // AJAX-Anfrage nur bei 'change'
                    });

                    var minCostInput = document.getElementById('minCost');
                    var maxCostInput = document.getElementById('maxCost');

                    

                    minCostInput.addEventListener('change', () => {
                        slider.noUiSlider.set([minCostInput.value.replace(' (€)', ''), null]);
                    });

                    maxCostInput.addEventListener('change', () => {
                        slider.noUiSlider.set([null, maxCostInput.value.replace(' (€)', '')]);
                    });
                },
            
    onFormChange() {
      this.fetchProducts(this.filters);
    },

    fetchProducts(filters) {
      this.loading = true;
      this.loadedProductIndex = 15; 
      $.ajax({
        url: '/wp-content/plugins/monitorFinderNewTry/testNeuFinderApp.php',
        method: 'POST',
        dataType: 'json',
        data: {
          filters: filters,
          limit: this.loadedProductIndex
        },
        success: (response) => {
          this.loading = false;
          this.products = response.filteredProducts;
          
          if(response.topProducts){
            this.topProducts = response.topProducts;
          }
            

          
        },
        error: (xhr, status, error) => {
          console.error('AJAX Fehler:', status, error);
    }
      });
    },


    flipCard(index) {
      const cardIndex = this.flippedCards.indexOf(index);
      if (cardIndex === -1) {
        this.flippedCards.push(index);
      } else {
        this.flippedCards.splice(cardIndex, 1);
      }
    },
    isFlipped(index) {
      return this.flippedCards.includes(index);
    },
    
    getCardAnimationClass(index) {
      const delay = (index + 1) * 25;
      return `animate__animated animate__fadeInUp animate__${delay}ms`;
    },

    // Funktion spaeter zum neue Produkte laden!
    updateMonitors() {
      this.loadedProductIndex += 15;
      $.ajax({
        url: "/wp-content/plugins/monitorFinderNewTry/testNeuFinderApp.php",
        method: "POST",
        data: {
          filters: this.filters,
          limit: this.loadedProductIndex
        },
        dataType: "json",
        success: (response) => {
          // Aktualisiere das Vue.js-Datenmodell oder verarbeite die Daten auf andere Weise
          // Beispiel: this.products = response;
          this.products = response.filteredProducts;
            
          if(response.topProducts){
            this.topProducts = response.topProducts;
          }
          
        },
        error: (error) => {
          console.log(answeredQuestions);
          console.log(selectedOptions);
          console.error(error);
        },
      });
    }
  },

  mounted() {
    this.initializeSlider();
    this.fetchProducts(this.filters); // Initialer Aufruf, um alle Produkte zu laden
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
    /* Stile für die Slider-Checkboxen */
    .form-check-input[type="checkbox"].form-check-input {
        width: 40px; /* Ändere die Breite nach Bedarf */
        height: 20px; /* Ändere die Höhe nach Bedarf */
    }

    /* Optional: Ändere den Rand und die Polsterung für ein besser aussehendes Design */
    .form-check-input[type="checkbox"].form-check-input {
        margin-right: 10px;
        padding: 5px;
    }
  
    .bg-cs-color{
      background-color: #c2ab9282;
    }

    .spanField{
      border-radius: 10px 10px 0 0;
    }

    .spanSelectField{
      border-radius: 0 10px 10px 10px;
      border-width: 1px;
      border-color: #DDD1C5
    }

    .spanSelectField:focus {
  outline: none; /* Entfernt den Standard-Fokus-Rahmen */
  border-color: #c2ab9282; /* Ändert die Farbe des Rahmens */
  box-shadow: 0 0 5px #c2ab9282; /* Ändert den Schatten */
}

.flip-card-3D-wrapper {
  perspective: 1000px;
}

.datasheet-button{

}

.card {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin: 5px;
  text-align: center;
  transform-style: preserve-3d;
  transition: transform 0.5s;
  display:flex;
}



.card.is-flipped {
  transform: rotateY(180deg);
}

.card-front,
.card-back {
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
}

.card-body{
  padding:0px;
}

.card-back {
  transform: rotateY(180deg);
  position:absolute;
  /* This background is !essential! to make the flip work on firefox */
  background-color: #fff;
}

.label-data-front {
color: #999

}

@media (min-width: 992px) {
  .custom-width-desktop {
    width: 25%;
  }
}

.scrolly {
    max-height: 900; 
    overflow-y: auto; 
     border: 1px solid #ccc;
}

.icon-margin-right {
            margin-right: 8px; /* Abstand nach rechts */
        }

.loading-spinner {
            border: 16px solid #f3f3f3; /* Light grey */
            border-top: 16px solid #c2ab9282; /* Blue */
            border-radius: 50%;
            width: 120px;
            height: 120px;
            animation: spin 2s linear infinite;
            margin: auto;
        }

        @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
        }
.shop-info{
  text-align: left;
  /*align-content: center;*/
}

.scrollable-div::-webkit-scrollbar-track {
  background-color: #f1f1f1; /* Helle graue Farbe für den Track /
  border-radius: 10px; /* Abgerundete Ecken */
}


.scrollable-div::-webkit-scrollbar-thumb {
  background-color: #888;  
  border-radius: 10px; 
  border: 3px solid #f1f1f1; 
}


.scrollable-div::-webkit-scrollbar {
  width: 12px;  
}

.scrollable-div {
  scrollbar-width: thin;
  scrollbar-color: #888 #f1f1f1;
}

  /* Standard Stil für kleine Bildschirme */
  .scrollable-container {
    height: auto !important;
    overflow-y: visible;
    position: static;
  }

  /* Stil für große Bildschirme */
  @media (min-width: 992px) {
    .scrollable-container {
      height: 1000px !important;
      overflow-y: auto;
      position: sticky;
      top: 0px;
    }
  }

  .btn12 {
    background-color: #fa890052;
  }
    .form-select-md-lg {
  padding: 0.375rem 0.65rem;       /* md: 0.375rem / lg: 0.75rem → hier 0.5rem */
  font-size: 1.2rem;           /* md: 1rem / lg: 1.25rem → hier 1.125rem */
  line-height: 1.5;
  border-radius: 0.25rem;        /* md: 0.25rem / lg: 0.3rem */
}

.winner-card {
  background-color: #ffffff;
  border: 2px solid #2f2a26;
  box-shadow: 4px 4px 0px #2f2a26;
  position: relative;
  transition: all 0.2s ease-in-out;
  border-radius: 0;
  
  display: flex;
  flex-direction: column;
  height: 100%; 

  /* --- NEU: Abstände für Mobile --- */
  margin-top: 15px; /* Gibt dem Ribbon (-12px) nach oben Platz, damit es nicht abgeschnitten wird */
}

/* --- NEU: Auf großen Bildschirmen (Desktop) den unteren Abstand entfernen --- */
/* (Da sie hier nebeneinander stehen, brauchen sie den margin-bottom nicht) */
@media (min-width: 992px) {
  .winner-card {
    margin-bottom: 0;
  }
}

.winner-card:hover {
  transform: translateY(-2px);
  box-shadow: 6px 6px 0px #1a1a1a;
}

/* Innerer Container (Dein <div class="p-3">) flexibel machen */
.winner-card > .p-3 {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  padding: 1.5rem !important; /* Etwas mehr Padding für den Tailwind-Look */
}

/* 3. Typografie in der Karte */
.winner-card h5 {
  font-family: 'Space Grotesk', sans-serif;
  font-weight: 700;
  font-size: 1.25rem;
  line-height: 1.2;
  margin-bottom: 1rem;
}

.winner-card .price {
  font-family: 'Space Grotesk', sans-serif;
  font-weight: 700;
  font-size: 1.5rem;
  display: block;
  margin-top: auto; /* Drückt den Preis nach unten zum Button */
}

/* 4. Badges / Fähnchen mit 3D-Falten-Effekt */
.badge-ribbon {
  position: absolute;
  top: -25px;
  left: -12px;
  padding: 8px 16px;
  font-family: 'Space Grotesk', sans-serif;
  font-weight: 700;
  letter-spacing: 0.05em;
  font-size: 0.875rem;
  z-index: 10;
  box-shadow: 2px 2px 0px #1a1a1a;
}

/* Der kleine Knick links unten am Fähnchen */
.badge-ribbon::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 0;
  border-left: 8px solid transparent;
}

/* Farben der jeweiligen Badges und deren Schatten/Falten */
.badge-testsieger {
  background-color: #627282;
  color: white;
}
.badge-testsieger::after {
  border-top: 8px solid #627282; /* Dunkleres Orange für den Knick */
}

.badge-preisleistung {
  background-color: #2f2a26;
  color: white;
}
.badge-preisleistung::after {
  border-top: 8px solid #000000;
  opacity: 0.8; /* Simuliert einen dunkleren Schatten */
}

.badge-gaming {
  background-color: #0d6efd;
  color: white;
}
.badge-gaming::after {
  border-top: 8px solid #2a2a2a;
}

/* 5. Button & Link verhalten */
/* Wichtig: Der Link-Tag muss ein Block-Element sein, damit er den Boden ausfüllt */
.winner-card a {
  display: block;
  width: 100%;
  text-decoration: none;
  margin-top: auto;
}

.btn-primary {
  background-color: #f45d2f;
  color: white;
  font-family: 'Space Grotesk', sans-serif;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border: none;
  padding: 16px; /* Höherer Button für mehr Klickfläche wie im Tailwind-Design */
  border-radius: 0;
  transition: background-color 0.2s;
  cursor: pointer;
  display: block; /* Sichert ab, dass der Button die volle Breite nimmt */
}

.btn-primary:hover {
  background-color: #d14016;
}
</style>
